var map = {
	"./avatar.png": "6c7c",
	"./avatar2.png": "a6f5",
	"./avatar3.png": "d1a2",
	"./award.png": "92bf",
	"./user-1-banner.jpeg": "7b59",
	"./user-2-banner.jpeg": "974c",
	"./user-3-banner.jpeg": "a20e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a8f";